import { createCollectionReducer } from 'reducers/account/collections';
import { selectAccountMeta } from 'reducers/account/meta';
import { TYPE } from './actions';

export default createCollectionReducer(TYPE);

export const selectEndUserProfiles = state => state[TYPE]?.profiles;
export const selectEndUserProfilesWithIdentifiers = state => {
  const profiles = selectEndUserProfiles(state);
  const profilesWithIdentifiers = profiles?.map(profile => {
    const userProfileIdentifier =
      selectAccountMeta(state)?.userProfileIdentifier;

    return {
      ...profile,
      identifier: userProfileIdentifier,
    };
  });
  return profilesWithIdentifiers;
};
